import { GlIcon, GlTooltipDirective } from '@gitlab/ui';
import { i18n } from '../constants';
export default {
    name: 'MergeRequestStatistics',
    i18n,
    components: {
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        mergeRequest: {
            type: Object,
            required: true
        }
    }
};
